<template>
  <div class="page">
    <TitleHeader :title="title" />
    <slot/>
    <div class="last-component"></div>
  </div>
</template>

<script>
import TitleHeader from "@/components/layout/utils/TitleHeader";
export default {
  name: "FullPage",
  components: {TitleHeader},
  props : {
    title : {
      type : String,
      required : true,
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  background: white !important;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
.last-component{
  margin-bottom: 75px;
}
</style>